import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useDialogStore } from '@stores/dialog.store'

import type Collection from '@models/Collection'

interface Props {
  collection: Collection
}

const DeleteCollectionButton: React.FC<Props> = ({ collection }: Props) => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="font-medium ml-2.5"
        onClick={() => openDialog('confirm_delete_collection', { state: collection })}>
        {t('action.deleteCollection')}
      </Button>
    </>
  )
}

export default DeleteCollectionButton
